import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var ExpansionPanelComponent = (function () {
    function ExpansionPanelComponent(translate) {
        this.translate = translate;
        this.panelOpenState = false;
        this.titleChange = new EventEmitter();
        this.selectedExercises = [];
        this.onDone = new EventEmitter();
        this.onRemove = new EventEmitter();
        this.step = 0;
    }
    Object.defineProperty(ExpansionPanelComponent.prototype, "title", {
        get: function () {
            return this.titleValue;
        },
        set: function (val) {
            this.titleValue = val;
            this.titleChange.emit(this.titleValue);
        },
        enumerable: true,
        configurable: true
    });
    ExpansionPanelComponent.prototype.remove = function (ex) {
        this.onRemove.emit(ex);
        if (this.selectedExercises.length == 0) {
            this.step = 0;
        }
    };
    ExpansionPanelComponent.prototype.setStep = function (index) {
        this.step = index;
    };
    ExpansionPanelComponent.prototype.nextStep = function () {
        this.step++;
    };
    ExpansionPanelComponent.prototype.forceSetStep = function (event, step) {
        this.setStep(step);
        event.stopPropagation();
    };
    ExpansionPanelComponent.prototype.prevStep = function () {
        this.step--;
    };
    ExpansionPanelComponent.prototype.imDone = function () {
        this.onDone.emit();
    };
    return ExpansionPanelComponent;
}());
export { ExpansionPanelComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/expansion-panel/expansion-panel.component.ts.pre-build-optimizer.js